// removed by extract-text-webpack-plugin
module.exports = {"ui":"item_ui_9pr14c","icon":"item_icon_4f2pt6","withIcon":"item_withIcon_debrzb","withSelected":"item_withSelected_88ovqq"};


//////////////////
// WEBPACK FOOTER
// ./packages/lib-ui/src/input/select/item/item.scss
// module id = 549
// module chunks = 0